'use client';

import { User } from 'next-auth';
import { useEffect } from 'react';

/**
 * See https://posthog.com/docs/getting-started/identify-users
 */
export function Posthog({ user }: { user: User }) {
  useEffect(() => {
    if (window.posthog && user.email) {
      console.info('🦔 PostHog identify call:', user.email);
      window.posthog.identify(user.email, user);
    }
  }, [user]);

  return null;
}
